import { subMonths as subMonthsFns, addMonths as addMonthsFns, differenceInMonths as differenceInMonthsFn, startOfMonth as startOfMonthFn } from 'date-fns';
/**
 * Calculates the date based on subtracting a number of months from one date.
 *
 * @param {Date} date - The date months are to be subtracted from.
 * @param {number} amount - The number of months to be subtracted.
 * @returns {Date} - Provided date minus however many months.
 */
export const subMonths = (date, amount) => subMonthsFns(date, amount);
/**
 * Calculates the date based on adding a number of months to one date.
 *
 * @param {Date} date - The date months are to be added to.
 * @param {number} amount - The number of months to be added.
 * @returns {Date} - Provided date plus however many months.
 */
export const addMonths = (date, amount) => addMonthsFns(date, amount);
/**
 * Finds the number of full months between two dates.
 *
 * @param {Date} leftDate - The first date for comparison.
 * @param {Date} rightDate  - The second date for comparison.
 * @returns {number} - The number of full months between the two dates.
 */
export const differenceInMonths = (leftDate, rightDate) => differenceInMonthsFn(leftDate, rightDate);
/**
 * Given a date, returns the date and timestamp of the very beginning of that month.
 *
 * @param {Date} date - The date to find the start of month from.
 * @returns {Date} - The very beginning of that month.
 */
export const startOfMonth = (date) => startOfMonthFn(date);
//# sourceMappingURL=month-helpers.js.map